<template>
  <v-flex
    class="sfh-login-header text-xs-center"
    :class="headerClass">
    <v-layout
      v-if="!isAuth && isCompactHeader && ['Home', 'Login'].includes(pageRoute)"
      align-center justify-space-between>
      <div style="width: 100%;padding-left: 40px" class="pt-2">
        <router-link class="ml-2 mt-2 router-link-active"  to="/">
          <img
            height="40"
            :src="appIconWithText"
            style="cursor:pointer;"
            :alt="appName" />
        </router-link>
        <h2
          class="white--text font-weight-regular line-height-1 pt-2"
          v-text="'Food Protection Manager Course'"/>
      </div>
      <div>
        <v-toolbar-side-icon
          class="text-shadow notranslate" dark
          @click.stop="$store.commit('toggleGuestLeftDrawer', !guestLeftDrawer)"
        ></v-toolbar-side-icon>
      </div>
    </v-layout>

    <v-layout
      v-if="!isAuth && isCompactHeader  && !['Home', 'Login'].includes(pageRoute)"
      :style="isCompactHeader && {height: headerHeight}"
      align-center justify-space-between>
      <div style="width: 100%;">
        <router-link class="d-flex ml-3 router-link-active"  to="/">
          <img
            height="40"
            :src="appIcon"
            style="cursor:pointer;"
            :alt="appName" />
        </router-link>
        <h2
          class="white--text font-weight-regular line-height-1 pt-2"
          v-text="appName"/>
      </div>
      <div>
        <v-toolbar-side-icon
          class="text-shadow notranslate" dark
          @click.stop="$store.commit('toggleGuestLeftDrawer', !guestLeftDrawer)"
        ></v-toolbar-side-icon>
      </div>
    </v-layout>

    <!-- For Sticky top --->
    <v-layout  v-if="!isAuth && !isCompactHeader" row align-center justify-center>
      <v-flex text-xs-left :style="{display: 'flex', 'align-items': 'center'}">
        <router-link class="d-flex ml-3 router-link-active"  to="/">
          <img :src="appIcon"
               height="40"
               :alt="appName">
        </router-link>

        <h2
          :class="titleClass()"
          class="white--text font-weight-regular float-left ml-1"
          :style="titleStyle()"><span v-text="title"/>
        </h2>
      </v-flex>
      <v-flex xs2 text-xs-right>
        <v-toolbar-side-icon class="text-shadow notranslate"  dark  @click.stop="$store.commit('toggleGuestLeftDrawer', !guestLeftDrawer)"
        ></v-toolbar-side-icon>
      </v-flex>
    </v-layout>

    <!--- USER LOGGED IN --->
    <div v-if="isAuth && isCompactHeader">
      <v-layout
        row wrap align-center justify-center user-logged-in
        :style="{height: headerHeight}">
        <v-flex xs2>
          <router-link class="d-flex ml-3 router-link-active"  to="/">
            <img
              height="40"
              :src="appIcon"
              style="cursor:pointer;"
              :alt="appName" />
          </router-link>
        </v-flex>
        <v-flex xs8></v-flex>
        <v-flex xs2 text-xs-right>
          <v-toolbar-side-icon  class="text-shadow notranslate"  dark  :class="currentStep === 3 ? 'current-step':''"
                                @click.stop="$store.commit('toggleRightDrawer', !rightDrawer)"
          ></v-toolbar-side-icon>
        </v-flex>
      </v-layout>
      <v-flex xs12 style="margin-top:-30px; height:60px;z-index: 1;position:relative; ">
          <div class="user-avatar elevation-10"
              :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'90px',width:'90px' }"></div>
      </v-flex>
    </div>
    <!-- For Sticky top --->
    <v-layout  v-if="isAuth && !isCompactHeader" align-center justify-space-between py-2>
      <div class="d-flex align-center">
        <router-link class="d-flex ml-3 router-link-active"  to="/">
          <img :src="appIcon"
               height="40"
               :alt="appName" />
        </router-link>
        <span style="font-size: 20px;" class="pl-2">
          <span class="white--text font-weight-regular float-left mt-2 line-height-1"
             style="text-align: left;" v-html="title" />
          <span v-if="$store.getters.getPageSubTitle"
                class="text-xs-left white--text font-italic" v-text="$store.getters.getPageSubTitle"/>
        </span>
      </div>
      <div>

        <v-list-tile avatar class="user-top-avatar">
          <v-list-tile-avatar>
            <img :src="$store.getters['user/avatar']" />
          </v-list-tile-avatar>
          <v-toolbar-side-icon  dark   class="text-shadow notranslate"  :class="currentStep === 3 ? 'current-step':''"
                                @click.stop="$store.commit('toggleRightDrawer', !rightDrawer)"
          ></v-toolbar-side-icon>
        </v-list-tile>
      </div>
    </v-layout>


    <navigation-menu></navigation-menu>
    <guest-left-navigation-menu></guest-left-navigation-menu>
  </v-flex>

</template>

<script>
  import NavigationMenu from './NavigationMenu'
  import GuestLeftNavigationMenu from './GuestLeftNavigationMenu'
  import { DEVICE_WIDTH, SINGLE_LINE_MAX_TITLE_LEN } from '@/mixins/constants'

  const { I_PHONE_5, I_PHONE_X, I_PAD } = DEVICE_WIDTH

  export default {
    name: 'Header69',
    components: {
      GuestLeftNavigationMenu,
      NavigationMenu
    },
    props: {
      className: {
        default: '',
        type: String
      },
      headerHeight: {
        default: '70px',
        type: String
      }
    },
    data () {
      return {
        clipped: false,
        hasAvatar: true,
        appName: process.env.APP_NAME,
        appIconWithText: require('@/assets/logos/SPLAT_Horizontal.png'),
        appIcon: require('@/assets/logos/' + process.env.APP_ICON)
      }
    },
    computed: {
      pageRoute: function () {
        return this.$route.name || ''
      },
      headerClass () {
        if (this.className) {
          return this.className
        } else
        if (this.isAuth) {
          if (this.isCompactHeader) {
            return 'pa-1'
          } else {
            return 'pa-1 text-xs-left'
          }
        } else {
          if (this.isCompactHeader) {
            return 'pt-2 pb-3'
          } else {
            const py = this.appWidth <= I_PHONE_5 ? 'py-1' : 'py-3'
            return `${py} text-xs-left`
          }
        }
      },
      title: {
        get: function () {
          let title = typeof this.$route.meta.pageTitle !== 'undefined' ? this.$route.meta.pageTitle : ''
          if (this.$route.name === 'ProgramLevels') {
            title = this.$store.getters.getPageTitle
          }

          return title
        },
        set: function () {
        }
      },
      isCompactHeader: {
        get: function () {
          return this.$store.getters.getIsCompactHeader
        },
        set: function (val) {
          this.$store.commit('setIsCompactHeader', val)
        }
      },
      currentStep: {
        get: function () {
          return this.$store.getters.getTourCurrentStep
        },
        set: function () {
          // setting db object
        }
      },
      isAuth () {
        return this.$auth.check()
      },
      userDetails () {
        return this.$store.getters['user/getUserDetails']
      },
      avatarLetters () {
        return this.$store.getters['user/avatarLetters']
      },
      username () {
        return localStorage.getItem('email')
      },
      rightDrawer: {
        get: function () {
          return this.$store.getters.rightDrawer
        },
        set: function (value) {
          this.$store.commit('toggleRightDrawer', value)
        }
      },
      guestLeftDrawer: {
        get: function () {
          return this.$store.getters.guestLeftDrawer
        },
        set: function (value) {
          this.$store.commit('toggleGuestLeftDrawer', value)
        }
      },
      appWidth () {
        return this.$store.getters.getAppWidth
      }
    },
    created () {
    },
    methods: {
      titleClass () {
        return this.title.length > SINGLE_LINE_MAX_TITLE_LEN ? 'mt-2 line-height-1' : 'line-height-1-2'
      },
      titleStyle () {
        const fontSize = this.appWidth >= I_PAD ? '1.5em' : '1.4em'
        const marginRight = this.appWidth < I_PHONE_X ? '10px' : 'auto'
        return {
          textAlign: 'left',
          fontSize,
          marginRight
        }
      },
      openRoute (route) {
        if (route === '/') {
          const route = Object.keys(this.userDetails).length > 0 ? 'Programs' : 'Home'
          this.$router.push({name: route})
        } else {
          this.$router.push({name: route})
        }
      }
    }
  }
</script>
<style>
.user-top-avatar .v-list__tile{
  padding: 0 !important;
  justify-content: end;
}
.user-top-avatar .v-list__tile__avatar {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Header69.vue